import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-34b429c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { getAssignPieOption } from '@/utils/echarts-option/pie'
import { getChartPiePrimaryPalette } from '@/utils/chart-theme-colors'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import PieCenter from '@/views/dashboard/_components/echarts/pie-center.vue'

interface ChartDataItem {
  name: string
  value: number
  color?: string
  /** 与终端列表筛选项 system_type 一致时，点击扇区可 */
  system_type?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'system-version-distribution-chart',
  props: {
    data: { default: () => [] }
  },
  emits: ["sliceClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)
const { t, locale } = useI18n()

const cardTitle = computed(() => {
  void locale.value
  return t('groupClient.systemVersionDistributionTitle')
})

const pieCenterTitle = computed(() => {
  void locale.value
  return t('groupClient.chartPieTotalLabel')
})

const pieCenterUnit = computed(() => {
  void locale.value
  return t('groupClient.chartUnitTerminalShort')
})

const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

const defaultColors = computed(() => getChartPiePrimaryPalette())

// 计算TOP10数据
const top10Data = computed(() => {
  if (!props.data?.length) return []
  return [...props.data].sort((a, b) => b.value - a.value).slice(0, 10)
})

const chartData = computed(() => {
  return top10Data.value.map((item, index) => ({
    ...item,
    color: item.color || defaultColors.value[index % defaultColors.value.length]
  }))
})

const totalCount = computed(() =>
  chartData.value.reduce((sum, item) => sum + item.value, 0)
)

const hasData = computed(() => totalCount.value > 0)

/** 数据项是否携带 system_type，用于可点击与指针样式 */
const sliceClickable = computed(() =>
  chartData.value.some(item => item.system_type != null && !Number.isNaN(Number(item.system_type)))
)

function getChartData() {
  return chartData.value.map(item => ({
    value: item.value,
    name: item.name,
    system_type: item.system_type,
    itemStyle: {
      color: item.color,
    },
  }))
}

function createChart() {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
}

function getChartOption() {
  const option = {
    series: [{
      name: t('groupClient.systemVersionDistributionTitle'),
      data: getChartData(),
    }],
  }
  return getAssignPieOption(option, { unit: t('groupClient.chartUnitTerminalShort') })
}

function renderChart() {
  if (!chartInstance) return
  chartInstance.setOption(getChartOption())
}

function onChartSliceClick(params: { name?: string; data?: { system_type?: number } }) {
  const raw = params?.data?.system_type
  if (raw == null || raw === '') return
  const system_type = Number(raw)
  if (Number.isNaN(system_type)) return
  emit('sliceClick', { system_type, name: String(params.name ?? '') })
}

function initChart() {
  chartInstance?.dispose()
  createChart()
  renderChart()
  chartInstance?.on('click', onChartSliceClick)
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance?.resize()
})

watch(() => props.data, () => {
  if (!hasData.value) return
  if (!chartInstance) {
    nextTick(initChart)
  } else {
    renderChart()
  }
}, { deep: true })

watch(locale, () => {
  if (!hasData.value || !chartInstance) return
  renderChart()
})

useEchartsThemeSync(() => {
  if (chartInstance && hasData.value) renderChart()
})

onMounted(() => {
  if (hasData.value) {
    setTimeout(() => initChart(), 100)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance?.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: cardTitle.value,
    class: "system-version-distribution-chart-wrap chart-card"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: _normalizeClass(["chart", { 'chart--slice-clickable': sliceClickable.value }])
        }, null, 2),
        _createVNode(PieCenter, {
          title: pieCenterTitle.value,
          value: totalCount.value,
          unit: pieCenterUnit.value
        }, null, 8, ["title", "value", "unit"])
      ], 512), [
        [_vShow, hasData.value]
      ]),
      _withDirectives(_createVNode(EmptyData, {
        height: "100%",
        "bg-color": "transparent"
      }, null, 512), [
        [_vShow, !hasData.value]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})